/** @jsx jsx */
import { jsx, Flex } from 'theme-ui';
import React from "react"
import { graphql, Link } from "gatsby"
import { MDXRenderer } from "gatsby-plugin-mdx";
import Seo from "../components/seo";
import { MDXProvider } from "@mdx-js/react";
import CodeBlock from "../components/code-block";
import InlineCode from "../components/inline-code";
import { Disqus } from 'gatsby-plugin-disqus';

const components = {
  code: CodeBlock,
  inlineCode: InlineCode,
};

const Post = ({ data, pageContext: { postPath, prev, next} }) => {
  let disqusConfig = {
    url: `${data.site.siteMetadata.siteUrl + postPath}`,
    identifier: data.mdx.id,
    title: data.mdx.frontmatter.title,
  }

  return (
    <React.Fragment>
      <Seo title={data.mdx.frontmatter.title} description={data.mdx.excerpt} />
      <article>
        <MDXProvider components={components}>
          <h1 style={{ fontWeight: 800, fontSize: 36 }}>{data.mdx.frontmatter.title}</h1>
          <time dateTime={data.mdx.frontmatter.datetime} itemProp="datePublished">{data.mdx.frontmatter.date}</time>
          <MDXRenderer>
            {data.mdx.body}
          </MDXRenderer>
        </MDXProvider>
      </article>
      <Flex sx={{
        justifyContent: "space-between",
        marginBottom: 12,
      }}>
        {prev && (
          <Flex sx={{ maxWidth: 200 }}>
            <Link to={prev.node.fields.postPath} sx={{
              textDecoration: "none",
              color: '#2a7ae2',
            }}>
              <Flex sx={{ justifyContent: "center", alignItems: "center"}}>
                <span sx={{fontSize: 48 }}>←</span>
                <span>{prev.node.frontmatter.title}</span>
              </Flex>
            </Link>
          </Flex>
        )}
        {next && (
          <Flex sx={{ maxWidth: 200}}>
            <Link to={next.node.fields.postPath} sx={{
              textDecoration: "none",
              color: '#2a7ae2',
            }}>
              <Flex sx={{ justifyContent: "center", alignItems: "center"}}>
                <span>{next.node.frontmatter.title}</span>
                <span sx={{fontSize: 48 }}>→</span>
              </Flex>
            </Link>
          </Flex>
        )}
      </Flex>
      <Disqus config={disqusConfig} />
    </React.Fragment>
  )
}

export default Post;

export const query = graphql`
  query ($title: String) {
    site {
      siteMetadata {
        siteUrl
      }
    }
    mdx(frontmatter: {title: {eq: $title}}) {
      frontmatter {
        title
        datetime: date
        date(formatString: "MMMM D, YYYY")
        category
      }
      id
      body
    }
  }
`